import { compile } from 'path-to-regexp'


type Params = {
  [key: string]: string | number
}

const cache = {}

const getLinkWithParams = (link: string, params?: Params, encode: Boolean = false) => {
  if (!cache[link]) {
    cache[link] = compile(link, {
      encode: encode ? encodeURIComponent : undefined,
    })
  }

  return cache[link](params)
}


export default getLinkWithParams
